export default "__VITE_ASSET__DAT5sSgC__"